export const PASSKEY_ENROLMENT_NAMESPACE = 'passkeyEnrollment';
